export default __webpack_public_path__ + "static/media/loginimg.59c9390f.png";